import { TBaseActivity } from './activities/BaseActivity'
import { TCompanyUserActivity } from './activities/CompanyUserActivity'
import { TDocumentUploadActivity } from './activities/DocumentUploadActivity'
import { TManualQuoteActivity } from './activities/ManualQuoteActivity'
import { TMessageActivity } from './activities/MessageActivity'
import { TProductUpdateActivity } from './activities/ProductUpdateActivity'
import { TShipmentUpdateActivity } from './activities/ShipmentUpdateActivity'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
function isDefined(value: any): boolean {
  return value !== undefined && value !== null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isBaseActivity(obj: any): obj is TBaseActivity {
  return (
    typeof obj === 'object' &&
    isDefined(obj._id) &&
    isDefined(obj.type) &&
    isDefined(obj.createdAt) &&
    isDefined(obj.updatedAt) &&
    isDefined(obj.referenceId) &&
    isDefined(obj.internal)
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isMessageActivity(activity: any): activity is TMessageActivity {
  return isBaseActivity(activity) && activity.type === 'message'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isDocumentUploadActivity(activity: any): activity is TDocumentUploadActivity {
  return isBaseActivity(activity) && activity.type === 'documentUpload'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isCompanyUserActivity(activity: any): activity is TCompanyUserActivity {
  return isBaseActivity(activity) && activity.type === 'companyUserUpdate'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isManualQuoteActivity(activity: any): activity is TManualQuoteActivity {
  return isBaseActivity(activity) && activity.type === 'manualQuote'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isShipmentUpdateActivity(activity: any): activity is TShipmentUpdateActivity {
  return isBaseActivity(activity) && activity.type === 'shipmentUpdate'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export function isProductUpdateActivity(activity: any): activity is TProductUpdateActivity {
  return isBaseActivity(activity) && activity.type === 'productUpdate'
}
